import React from 'react';
import * as Survey from 'survey-react';

Survey.Survey.cssType = 'bootstrapmaterial';
Survey.defaultBootstrapMaterialCss.navigationButton = 'btn btn-primary';

const Feedback = ({ data, json, onComplete }) => {
  const model = new Survey.Model(json);
  model.data = data;

  return (
    <div className="panel panel-default survey">
      <Survey.Survey model={model} json={json} onComplete={(s) => onComplete(s.data)} />
    </div>
  );
};

export default Feedback;
